import React, { useCallback } from "react";
import { connect } from "react-redux";

import Radio from "antd/es/radio";
import { useIntl } from "react-intl";

import { EntityType, EntityTypesSupportingRoutes } from "@mapmycustomers/shared/types/entity";

import RadioGroup from "@app/component/input/RadioGroup";
import { smartPlannerViewAnalytics } from "@app/scene/activity/activityTableAnalytics";
import { RootState } from "@app/store/rootReducer";
import { getEntityTypeDisplayName } from "@app/util/ui";

import { getEntityType } from "../../store";
import { setEntityType } from "../../store/actions";

import styles from "./Setup.module.scss";

interface Props {
  entityType: EntityTypesSupportingRoutes;
  onChangeEntityType: (entityType: EntityTypesSupportingRoutes) => void;
}

const EntityTypeSelector: React.FC<Props> = ({ entityType, onChangeEntityType }) => {
  const intl = useIntl();

  const updatedEntityType = useCallback(
    (value) => {
      smartPlannerViewAnalytics?.using(["Build routes from activities", "Record type selector"], {
        recordType: getEntityTypeDisplayName(intl, value, { lowercase: false, plural: true }),
      });
      onChangeEntityType(value);
    },
    [intl, onChangeEntityType]
  );
  return (
    <div className={styles.selector}>
      <span>
        {intl.formatMessage({
          id: "activities.calendarView.routeBuilder.steps.setup.entityTypeSelector.title",
          defaultMessage: "Build route using",
          description: "Title of record type selector in Route Builder in Activities Calendar view",
        })}
      </span>
      <RadioGroup onChange={updatedEntityType} value={entityType}>
        {[EntityType.COMPANY, EntityType.PERSON].map((entityType) => (
          <Radio.Button key={entityType} value={entityType}>
            {getEntityTypeDisplayName(intl, entityType, { lowercase: false, plural: true })}
          </Radio.Button>
        ))}
      </RadioGroup>
    </div>
  );
};
const mapStateToProps = (state: RootState) => ({
  entityType: getEntityType(state),
});

const mapDispatchToProps = {
  onChangeEntityType: setEntityType,
};

export default connect(mapStateToProps, mapDispatchToProps)(EntityTypeSelector);
